import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "CalendarUnifiedTelemetryUtils" */ './lazyIndex'),
    { name: 'CalendarUnifiedTelemetryUtils' }
);

export const lazyCreateOpenEventUnifiedEventFromMeetingRequest: LazyImport<
    typeof lazyIndex.createOpenEventUnifiedEventFromMeetingRequest,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.createOpenEventUnifiedEventFromMeetingRequest);

export const lazyLogCalendarPlanModeEvent: LazyAction<
    typeof lazyIndex.logCalendarPlanModeEvent,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logCalendarPlanModeEvent);

export const lazyLogPlanOperationEdit: LazyAction<
    typeof lazyIndex.logPlanOperationEdit,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.logPlanOperationEdit);

// Direct exports for types only (no runtime code = zero bundle impact)
export type { PlanModeData, PlanModeEventOptions } from './utils/planModeDataTypes';
export type { PlanOperationEditOptions } from './utils/logPlanOperationEdit';
